import React, { useEffect } from 'react';

import Button from '../../library/button/button';
import DefaultLayout from '../../layouts/default-layout/default-layout';

import { trackAction } from '../../shared/utils/analytics/analytics';

import './error-page.scss';

function ErrorPage() {
  useEffect(() => {
    trackAction('error_page_view');
  }, []);

  return (
    <DefaultLayout>
      <div styleName="container">
        <h2>We&apos;ve got a problem...</h2>
        <p>
          Sorry to say it, but something unexpected happened and we can&apos;t
          display the page we had hoped to.
        </p>
        <Button href="/" isPrimary>
          Continue Shopping
        </Button>
      </div>
    </DefaultLayout>
  );
}

export default ErrorPage;
